<template>
  <div id="nav">
    <div class="link" v-show="show(page[1])">
			<a href="/">home</a>
			<div class="underline"></div>
		</div>
    <div class="link" v-show="show(page[0])">
			<a href="/about">about</a>
			<div class="underline"></div>
		</div>
  </div>
  <router-view/>
</template>

<script>

export default {
	data() {
		return {
			page: ["/","about"]
		}
	},
	methods: {
		show(page) {
			if ( this.$route.path === "/" && page === "/" ) {
				return true
			}
			else if ( this.$route.path === "/about" && page === "about" ) { 
				return true
			}
			else { return false }
		},
	},
	
}

</script>

<style>
@font-face {
  font-family: "Lato";
  src: local("Lato"), url(./fonts/Lato/Lato-Regular.ttf) format("truetype");}

@font-face {
  font-family: "Lato-b";
  src: local("Lato-b"), url(./fonts/Lato/Lato-Bold.ttf) format("truetype");}


@font-face {
  font-family: "Newsreader";
  src: local("Newsreader"), url(./fonts/Newsreader/Newsreader-LightItalic.ttf) format("truetype");}

@font-face {
  font-family: "Newsreader-b";
  src: local("Newsreader-b"), url(./fonts/Newsreader/Newsreader-BoldItalic.ttf) format("truetype");}


:root {
	--col0: #002C6A ;
	--col1:#2c318d;
	--col2:#658DA3;
	--col3:#9E2899;
	--black: #333;
	--tr: hsla(0, 0%, 0%, 0.6);
	--grey:#a2a3c4;
	--font: "Lato", Helvetica, Arial, sans-serif;
	--bold: "Lato-b", Helvetica, Arial, sans-serif; 
	--math: "Newsreader", sans-serif;
	--math-b: "Newsreader-b", sans-serif; 
}

.bold {
	font-family: var(--bold); 
	font-size: 16px;
}

.col1 {
	color: var(--col1);
}

.col2 {
	color: var(--col2);
}

.col3 {
	color: var(--col3);
}

.col1b {
	background:var(--col1);
}

.col2b {
	background:var(--col2);
}
.col3b {
	background:var(--col3);
}

.link {
	float:right;
	position: relative;
	width: 70px;
	text-align: center;
}

.underline {
	position: absolute;
	width: 0%;
	background-color:var(--col1);
	opacity: 0.5;
	height:2px;
	bottom:8px;
	z-index:-1;
}

.link:hover > .underline {
	animation: transition 0.15s 1 ease-in forwards;
}

@keyframes transition {
	0% {
		width: 0%; 
	}
	100% {
		width: 100%;
	}
}

#app {
	padding: 5px;
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;
	text-align: right;
}

#nav a {
	font-weight:bold;
	text-decoration: none;
	color: var(--col0);
}

#nav a:hover {
	animation: hovering 2s infinite;
}

.empty {
	height: 70px;
}

footer {
	padding-top: 20px;
}

@media only screen and (max-width: 500px) {
	#nav {
		padding: 10px;
	}
}

</style>
